import { Component, Input, OnInit } from '@angular/core';
import * as Models from '../../../models/models-index';
import { of, map, Observable, tap } from 'rxjs';
import { FilterService } from '../../../services/services-index';

@Component({
    selector: 'kpi-metric',
    templateUrl: './kpi-metric.component.html',
    styleUrls: ['../panel-elements.scss', './kpi-metric.scss'],
    standalone: false
})

export class KpiMetricComponent implements Models.ElementComponent, OnInit {
  @Input() set dataSets(value: Models.DataSet[]) {
    if (!!value) {
      this.processData(value[0]);
      this.isDataSetLoaded$ = of(true);
    } else {
      this.isDataSetLoaded$ = of(false);
    }
  }

  isDataSetLoaded$ = of(false);

  @Input() settings: any;
  @Input() viewContext?: Models.ViewContext;

  get hasDynamicLink() {
    return !!this.settings.options?.['linkTemplate'];
  }

  metricValue;
  metricTrend;
  metricLabel;
  subtitleOne;
  subtitleOneLabel: string;

  constructor(
    private filterService: FilterService
  ) {
  }

  ngOnInit() {
  }

  private processData(dataSet: Models.DataSet): void {
    const metricIndex = dataSet.columns.findIndex(col => col.name === this.settings.metricName);
    const metricTrendIndex = dataSet.columns.findIndex(col => col.name === this.settings.metricTrend);
    const metricPreviousPeriodIndex = dataSet.columns.findIndex(col => col.name === this.settings.metricNamePreviousPeriod);

    // Error display for debugging
    if (metricIndex == -1) console.error("Could not find metric " + this.settings.metricName + ".  Make sure it's in the dataset.");
    if (metricTrendIndex == -1) console.error("Could not find trend metric in dataset for metric " + this.settings.metricName
      + ".  Make sure the TimeIntelligenceTransformStage has the proper mode field.");
    if (metricPreviousPeriodIndex == -1) console.error("Could not find previous period metric in dataset for metric " + this.settings.metricName
      + ".  Make sure the TimeIntelligenceTransformStage has the proper mode field.");

    this.metricValue = dataSet.rows[0][metricIndex].label ?? dataSet.rows[0][metricIndex].value;
    this.metricTrend = dataSet.rows[0][metricTrendIndex].value;
    this.metricLabel = this.settings.displayName ?? dataSet.columns[metricIndex].displayName ?? dataSet.columns[metricIndex].name;

    const metricPreviousPeriod = dataSet.rows[0][metricPreviousPeriodIndex];
    this.subtitleOne = metricPreviousPeriod?.label ?? metricPreviousPeriod?.value;
    this.subtitleOneLabel = this.settings.subtitleOneLabel ?? "Prev. Period:";
  }

  getDynamicLinkUrl(): Observable<string> {
    if (!this.viewContext?.reportName) {
      throw new Error('[kpi-metric] viewContext.reportName is required');
    }
    return this.filterService.getDynamicLinkUrl(this.viewContext, this.settings.options['linkTemplate'], this.settings.options['linkKeyMap']);
  }

  getTrendArrowIconClass(trend: number): string {
    const isTrendUp = this.isTrendUp(trend);

    if (isTrendUp === null || trend === 0) {
      return 'fa fa-horizontal-rule';
    } else if (trend > 0) {
      return 'fa fa-chevron-circle-up chevron-icon';
    } else if (trend < 0) {
      return 'fa fa-chevron-circle-down chevron-icon';
    }
  }

  getTrendIconColor(trend: number): string {
    const isTrendUp = this.isTrendUp(trend);

    if (isTrendUp === null) {
      return 'bg-yellow';
    } else if (!isTrendUp) {
      return 'bg-red';
    } else if (!!isTrendUp) {
      return 'bg-green';
    }
  }

  getTrendColor(trend: number): string {
    const isTrendUp = this.isTrendUp(trend);
    if (isTrendUp == null) {
      return 'text-yellow';
    } else if (!!isTrendUp) {
      return 'text-green';
    } else if (!isTrendUp) {
      return 'text-red';
    }
  }

  isTrendUp(value: number) {
    if (!value || value === 0)
      return null;

    return value > 0
      ? this.settings.metricInverted ? false : true
      : this.settings.metricInverted ? true : false;
  }
}
